<script lang="ts">
  import TextNew from "../TextNew.svelte";

  /**
   * expects "d EEE" format
   */
  export let day: string | undefined;
  export let month: string | undefined;
  export let date: string | undefined | null;
  export let rowIndex: number;
  export let dateCellRefs: HTMLDivElement[];
</script>

<div
  role="gridcell"
  class:first-row={rowIndex === 0}
  bind:this={dateCellRefs[rowIndex]}
  data-date={date}
  data-row={rowIndex}
>
  {#if day && month}
    <TextNew size="m" weight="medium">
      {day}
    </TextNew>
    <TextNew font="ocr" size="xs" --rk-text-color="var(--rk-text-low)">
      {month}
    </TextNew>
  {/if}
</div>

<style>
  div[role="gridcell"] {
    position: sticky;
    background-color: white;
    display: flex;
    left: 0px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-shadow: 0px 3px 0px 1px #fff;
  }
  :global(.invoice-data-grid__grid-cell__sticky) {
    top: 32px;
    padding-top: 12px;
    align-self: start;
    z-index: 2;
  }

  .first-row {
    margin-top: 8px;
  }
</style>
